"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var CanvasContent_1 = __importDefault(require("../../../../../../Components/Templates/CanvasContent/CanvasContent"));
var MediaCarouselContent = function (_a) {
    var content = _a.content, viewWidth = _a.viewWidth, viewHeight = _a.viewHeight, objectFit = _a.objectFit, background = _a.background;
    return (react_1.default.createElement("div", { style: {
            width: '100%',
            height: '100%',
            objectFit: objectFit,
            background: background
        } },
        react_1.default.createElement(CanvasContent_1.default, { content: content, screenResolutionWidth: viewWidth, screenResolutionHeight: viewHeight })));
};
exports.default = MediaCarouselContent;
//# sourceMappingURL=MediaCarouselContent.js.map